import _ from 'lodash'
import axios from 'axios'
import qs from 'qs'
import { Message } from 'element-ui'
import store from '../store'
import APP_CONSTS from './const-config'

const base = APP_CONSTS.BASE
const patternsIgnore = APP_CONSTS.PATTERNS_IGNORE
const loginPath = APP_CONSTS.LOGIN_PATH
const homePath = APP_CONSTS.HOME_PATH

const defaultTimeout = APP_CONSTS.AXIOS_TIMEOUT

const TEN_SECONDS = 10 * 1000

/**
 * Had to use `defaults` to make timeout work.
 * see: https://github.com/axios/axios/issues/1503
 * see: https://github.com/axios/axios/issues/647
 */
axios.defaults.timeout = defaultTimeout || TEN_SECONDS
axios.defaults.headers.post = { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }
axios.defaults.headers.put = { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }
axios.defaults.headers.patch = { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }

let pageLoadingTime = localStorage.getItem(window.location.href)

if (!pageLoadingTime) {
  pageLoadingTime = new Date().getTime()
  localStorage.setItem(window.location.href, pageLoadingTime)
}

/** 200 response, but also has follow critical errors. */
const GLOBAL_RS_CODE = { 403: '暂无权限', 400: '非法请求', 500: '服务异常，请联系管理员获取支持' }

axios.interceptors.request.use(config => {
  let url = config.url
  if (url.endsWith('/sso/whoami') || url.endsWith('/anon')) {
    return config
  }
  if (_.findIndex(patternsIgnore, e => (base + e) === url) !== -1) {
    return config
  }
  /* check if user login info reset by comparing "sso-token", and prevent alerting multi message box */
  if (!isLoggedUser()) {
    let nowTime = new Date().getTime()
    /* check to only reload once in 10s, as a page may have multi ajax requests */
    if (nowTime - pageLoadingTime > TEN_SECONDS) {
      console.log('login info invalid...', nowTime, pageLoadingTime, nowTime - pageLoadingTime, '登录信息已过期')
      pageLoadingTime = nowTime
      localStorage.setItem(window.location.href, pageLoadingTime)
      Message.error({ message: '登录信息已过期，请等待页面刷新后重试...' })
      setTimeout(redirectLogin, 500)
      /* return empty would **prevent** this ajax reqeust with error, How about using cancel token */
      return
    }
  }
  return config
}, err => {
  console.log(err)
  Message.error({ message: '请求异常' })
})

axios.interceptors.response.use(resp => {
  if (resp && resp.status === 200) {
    let rs = resp.data
    if (rs.code === 403) {
      redirectLogin()
      return
    }
    let msg = GLOBAL_RS_CODE[rs.code]
    if (msg) {
      Message.error({ message: msg })
      return rs
    }
    return rs
  }
}, err => {
  if (err.message === 'Network Error') {
    Message.error({ message: '网络异常，请重新登录' })
    window.location.href = loginPath + '?appBack=' + window.location.href
    return
  } else if (err.message.includes('timeout')) {
    Message.error({ message: '请求超时' })
    return
  }

  if (err.response.status === 500 || err.response.status === 504 || err.response.status === 404) {
    Message.error({ message: '未知错误，请联系管理员' })
  } else if (err.response.status === 401) {
    console.log('login info timeout... 401 redirect')
    localStorage.removeItem('user')
    window.location.href = loginPath + '?appBack=' + window.location.href
  } else {
    Message.error({ message: '未知错误' })
  }
  // return Promise.resolve(err)
})

/**
 * Delegate `axios.get` with hidden the `config.params` option. `params` must be JSON object.
 */
export const xhrGet = (url, params, config) => {
  return axios.get(`${base}${url}`,
    _.isNil(params) ? config : _.merge({}, { params: params }, config)
  )
}

const QS_STRINGIFY_OPTION = { skipNulls: true, indices: false }

/**
 * Delegate `axios.post`. `data` must be JSON object.
 * @param url post url
 * @param data form object
 * @param config axios config
 * @param qsOptions qs.stringfy options
 */
export const xhrPost = (url, data, config, qsOptions) => {
  return axios.post(`${base}${url}`,
    qs.stringify(data, qsOptions || QS_STRINGIFY_OPTION),
    config
  )
}

/**
 * Delegate `axios.put`. `data` must be JSON object.
 */
export const xhrPut = (url, data, config) => {
  return axios.put(`${base}${url}`,
    qs.stringify(data, QS_STRINGIFY_OPTION),
    config
  )
}

/**
 * Delegate `axios.patch`. `data` must be JSON object.
 */
export const xhrPatch = (url, data, config) => {
  return axios.patch(`${base}${url}`,
    qs.stringify(data, QS_STRINGIFY_OPTION),
    config
  )
}

/**
 * Delegate `axios.delete`.
 */
export const xhrDelete = (url, config) => {
  return axios.delete(`${base}${url}`, config)
}

/**
 * Upload file by `axios.post`.
 * @param {*} url url
 * @param {*} data `FormData`
 * @param {*} config axios config
 */
export const xhrFilePost = (url, data, config) => {
  if (!(data instanceof FormData)) {
    console.log('expect FormData', data)
  }
  return axios.post(`${base}${url}`, data, config)
}

/**
 * Upload file by `axios.put`.
 * @param {*} url url
 * @param {*} data `FormData`
 * @param {*} config axios config
 */
export const xhrFilePut = (url, data, config) => {
  if (!(data instanceof FormData)) {
    console.log('expect FormData', data)
  }
  return axios.put(`${base}${url}`, data, config)
}

/**
 * File download.
 */
export const fetchFile = (url) => {
  window.open(`${base}${url}`)
}

/**
 * Help method redirect to sso login.
 */
export const redirectLogin = () => {
  window.location.href = loginPath
}

/**
 * Help method redirect to unlogin page.
 */
export const redirectUnlogin = () => {
  window.location.href = homePath
}

export const isLoggedUser = () => {
  let user = store.state.user
  let ssoToken = (document.cookie.match('(^|[^;]+)\\s*' + 'sso-token' + '\\s*=\\s*([^;]+)') || []).pop()
  if (user && user.token && user.token === ssoToken) {
    return true
  }
  return false
}



// WEBPACK FOOTER //
// ./src/util/xhr-apis.js